var _defs, _rect, _ellipse, _circle, _circle2, _g, _g2, _g3, _g4, _g5, _g6, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravelBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 1000,
    viewBox: "0 0 1600 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0F1E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#1B2A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#3A4A63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B8863B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glow",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E9D6B0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E9D6B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bldg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0B1626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#16273F"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "url(#sky)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1200,
    cy: 760,
    rx: 700,
    ry: 380,
    fill: "url(#glow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 230,
    r: 70,
    fill: "#F4EAD4",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 230,
    r: 70,
    fill: "#0F1E33",
    opacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#EEF1F4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 140,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 90,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 170,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 110,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 220,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 80,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 180,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 60,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 200,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 60,
    r: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#E9D6B0",
    strokeWidth: 2,
    strokeDasharray: "2 14",
    opacity: 0.55,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -50 430 C 300 250, 650 260, 1000 150 S 1500 60, 1650 40"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(985,158) rotate(-18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L34 4 L44 0 L34 -4 Z M6 -1 L-4 -14 L2 -14 L14 -2 Z M6 1 L-4 14 L2 14 L14 2 Z",
    fill: "#EEF1F4",
    opacity: 0.92
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#bldg)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640,
    width: 90,
    height: 360
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 560,
    width: 70,
    height: 440
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 700,
    width: 110,
    height: 300
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 500,
    width: 85,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 620,
    width: 60,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 440,
    width: 100,
    height: 560
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 600,
    width: 75,
    height: 400
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 520,
    width: 90,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 660,
    width: 65,
    height: 340
  }), /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 580,
    width: 95,
    height: 420
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 700,
    width: 70,
    height: 300
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 480,
    width: 110,
    height: 520
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 640,
    width: 80,
    height: 360
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 560,
    width: 65,
    height: 440
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1305,
    y: 700,
    width: 100,
    height: 300
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415,
    y: 600,
    width: 75,
    height: 400
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500,
    y: 660,
    width: 100,
    height: 340
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#E9D6B0",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 670,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 670,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 710,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 710,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 600,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 600,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 640,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 680,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 740,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 740,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 780,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 820,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 540,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 540,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 590,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 640,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 690,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 480,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 480,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 530,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 580,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 630,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 680,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 640,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 640,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 680,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 560,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 560,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 610,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 660,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 855,
    y: 620,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 620,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 855,
    y: 670,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885,
    y: 720,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 520,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 520,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 570,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 620,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 670,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 680,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 680,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 720,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 600,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1270,
    y: 600,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 640,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 740,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1355,
    y: 740,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 790,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1435,
    y: 640,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 640,
    width: 10,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520,
    y: 700,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 700,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520,
    y: 750,
    width: 12,
    height: 16
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 900,
    width: 30,
    height: 60,
    fill: "#0B1626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 908,
    width: 18,
    height: 10,
    fill: "#E9D6B0",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 900 L455 875 L470 900 Z",
    fill: "#0B1626"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 960,
    width: 1600,
    height: 40,
    fill: "#0B1626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelBg);
export default __webpack_public_path__ + "static/media/travel-bg.23986bd410674cc4c74ffa47f9770831.svg";
export { ForwardRef as ReactComponent };